export const MAX_RATE_COMPLETE = 100;
